if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: 64,
      // Optional
      loadProductFirst: false,
      filterTreeMobileStyle: 'style1',
      requestInstantly: true,
      paginationType: 'load_more'
    },
    selector: {
      products: '#product-loop'
    },
    label: {
      loadMore: 'View more',
    }
  };
}

var boostPFSTemplate = {
  'saleLabelHtml': '<div class="sale-item icn">{{jdDiscountedPercentage}}</div>',
  'soldOutLabelHtml': '<div class="so icn">' + boostPFSConfig.label.sold_out + '</div>',
  'newLabelHtml': '<div class="new icn">' + boostPFSConfig.label.new + '</div>',
  'vendorHtml': '<h4>{{itemVendorLabel}}<h4>',
  'quickViewHtml': '<a class="fancybox.ajax product-modal" href="{{itemUrl}}?view=quick">' + boostPFSConfig.label.quick_view + '</a>',

  'productGridItemHtml':  '<div id="product-listing-{{itemId}}" class="product-index {{itemGridWidthClass}} tablet-half mobile-half {{jdProductClasses}}" data-alpha="{{itemTitle}}" data-price="{{itemPriceNumber}}">' +
  '<div id="jd-hidden" style="display: none;"></div>' +
  '<div class="product-index-inner">' +
  '{{itemNewLabel}}' +
  /*'{{itemSaleLabel}}' +*/
  '{{jdDiscountedPercentage}}'+
  '{{itemSoldoutLabel}}' +
  '</div>' +
  '<div class="prod-image">' +
  '{{itemFeaturedLabel}}' +
  '{{comboItemLabel}}' +
  '<a href="{{itemUrl}}" title="{{itemTitle}}">' +
  '<div class="reveal">' +
  '{{itemImages}}' +
  '</div>' +
  '</a>' +
  '{{itemQuickView}}' +
  '</div>' +
  '<div class="product-info">' +
  '<div class="product-info-inner">' +
  '<a href="{{itemUrl}}">' +
  '{{itemVendor}}' +
  '<span class="prod-title">{{itemTitle}}</span>' +
  '{{itemReviews}}' +
  '</a>' +
  '<div class="price">{{itemPrice}}</div>' +
  '{{itemSwatch}}' +
  '</div>' +
  '</div>' +
  '</div>',

  // Pagination Template
  'previousHtml': '<div class="pagiprev"><a href="{{itemUrl}}" title=""><i class="fa fa-caret-left"></i></a></div>',
  'nextHtml': '<div class="paginext"><a href="{{itemUrl}}" title=""><i class="fa fa-caret-right"></i></a></div>',
  'pageItemHtml': '<a href="{{itemUrl}}" title="">{{itemTitle}}</a>',
  'pageItemSelectedHtml': '<span class="current">{{itemTitle}}</span>',
  'pageItemRemainHtml': '{{itemTitle}}',
  'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  'paginateTopHtml': '{{previous}} <span class="pagination-count"></span> {{next}}',

  // Sorting Template
  'sortingHtml': '<select aria-label="Sort by" class="styled-select">{{sortingItems}}</select>',
};

if(Shopify.currency.active == "GBP"){
  var jdft_iso = "£";
} else if(Shopify.currency.active == "EUR") {
  var jdft_iso = "€";
} else {
  var jdft_iso = "$";
}

var store_settings = jQuery.parseJSON(jQuery("#jda_settings").text());
if(store_settings.jd_enable_sale == "true" && store_settings.jd_sale_type != "none" && store_settings.jd_sale_percentage != ""){
  var jd_enable_sale = true;
  var jd_sale_type = store_settings.jd_sale_type;
  var jd_sale_percentage = (100 - parseInt(store_settings.jd_sale_percentage)) / 100;
  if (store_settings.jd_discount_notice != "") {
    var jd_discount_notice = store_settings.jd_discount_notice;
  } else {
    var jd_discount_notice = false;
  }
} else {
  var jd_enable_sale = false;
  var jd_sale_type = false;
  var jd_discount_notice = false;
}

(function () {
  BoostPFS.inject(this);

  ProductGridItem.prototype.compileTemplate = function (data, index, totalProduct) {
    if(!data) data = this.data;
    if(!index) index = this.index + 1;
    if(!totalProduct) totalProduct = this.totalProduct;

    /*** Prepare data ***/
    //console.log('Printing product data: ', data);
    var images = data.images_info;
    //console.log("Junaid images: ", images)
    // Displaying price base on the policy of Shopify, have to multiple by 100
    const inventoryQuantities = data.variants.map((variant) => variant.inventory_quantity);
    const totalInventoryQuantity = inventoryQuantities.reduce((a, b) => a + b, 0);
    var soldOut = totalInventoryQuantity === 0; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) { return e.id == Utils.getParam('variant'); });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    
    // Add itemGridWidthClass
    var itemGridWidthClass = '';
    var productsPerRow = boostPFSConfig.custom.products_per_row;
    switch (productsPerRow) {
      case 6:
        itemGridWidthClass = buildItemGridClass('desktop-2', index, productsPerRow);
        break;
      case 4:
        itemGridWidthClass = buildItemGridClass('desktop-3 desktop-small-4', index, productsPerRow);
        break;
      case 3:
        itemGridWidthClass = buildItemGridClass('desktop-4', index, productsPerRow);
        break;
      case 5:
        itemGridWidthClass = buildItemGridClass('desktop-fifth', index, productsPerRow);
        break;
      case 2:
        itemGridWidthClass = buildItemGridClass('desktop-6', index, productsPerRow);
        break;
      default:
        break;
    }
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);


    var comboItemClass = "";
    
    if(data.tags.includes("Combo") || data.tags.includes("combo") || data.tags.includes("COMBO")){
      comboItemClass = "combo-item";
    } else {
      comboItemClass = "";
    }

    itemHtml = itemHtml.replace(/{{jdProductClasses}}/g, comboItemClass);

    // Add Label
    var itemNewLabelHtml = '';
    var itemSaleLabelHtml = '';
    var itemSoldoutLabelHtml = '';
    if (!soldOut) {
      for (var k in data.collections) {
        if (data['collections'][k]['handle'] == 'new') {
          itemNewLabelHtml = boostPFSTemplate.newLabelHtml;
          break;
        }
      }
      if (onSale) {
        itemSaleLabelHtml = boostPFSTemplate.saleLabelHtml.replace(/{{itemOldPrice}}/g, Utils.formatMoney(data.price_min, Globals.moneyFormat));
      }

      if(!onSale){
        itemSoldoutLabelHtml = '<rivo-favorite-button class="jd-collection-wishlist-save" data-product-id="'+data.id+'" rivo-ax-data rivo-ax-cloak rivo-ax-html="$store.icons.heart" rivo-ax-show="$store.rivo_aw_settings?.favorites_enabled && (!$store.rivo_profile_customer || $store.loading_states.global_favorite_buttons)"></rivo-favorite-button>';
      }
    } else {
      itemSoldoutLabelHtml = boostPFSTemplate.soldOutLabelHtml;
    }
    itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);
    itemHtml = itemHtml.replace(/{{itemSoldoutLabel}}/g, itemSoldoutLabelHtml);

    // junaid add best selling and feature adinas picks labels here

    var itemFeaturedLabel = '';

    for (var t in data.tags){
      if(data.tags[t].indexOf("new arrivals") >= 0 || data.tags[t].indexOf("New Arrivals") >= 0 || data.tags[t].indexOf("NEW ARRIVALS") >= 0 || data.tags[t].indexOf("new arrivals fine") >= 0){
        itemFeaturedLabel = '<div class="featured-label jd-icn">New Arrival</div>';
      }

      if(data.tags[t].indexOf("best sellers") >= 0 || data.tags[t].indexOf("Best Sellers") >= 0 || data.tags[t].indexOf("BEST SELLERS") >= 0 || data.tags[t].indexOf("14KBS") >= 0){
        itemFeaturedLabel = '<div class="featured-label jd-icn">Best Seller</div>';
      }
    }

    itemHtml = itemHtml.replace(/{{itemFeaturedLabel}}/g, itemFeaturedLabel);


    /* JUNAID ADD TOTAL SAVINGS FOR COMBO ITEMS ONLY */

    // Add price
    //var currency = Shopify.currency.active;
    var currency = "";
    //console.log("JD ACTIVE CURRENCY:", currency);
    if (currency == "USD")
      currency = "";

    var comboItemLabel = "";
    //console.log(data);
    for (var t in data.tags) {
      if (
        data.tags[t] == "combo" ||
        data.tags[t] == "COMBO" ||
        data.tags[t] == "Combo"
      ) {
        if (
          data.compare_at_price_min != "" &&
          data.compare_at_price_min > data.price_min
        ) {
          if (
            store_settings.jd_enable_sale == "true" &&
            store_settings.jd_sale_type == "sitewide" &&
            store_settings.jd_sale_percentage != ""
          ) {
            var comboItemSaving =
              data.compare_at_price_min - data.price_min * jd_sale_percentage;
          } else {
            var comboItemSaving = data.compare_at_price_min - data.price_min;
          }
          comboItemLabel =
            Utils.formatMoney(Math.floor(comboItemSaving), Globals.moneyFormat) +
            " " +
            currency;
          comboItemLabel =
            "<div class='jd-icn combo-label'>Save " + comboItemLabel + "</div>";
        } else {
          comboItemLabel = "";
        }
      }
    }
    itemHtml = itemHtml.replace(/{{comboItemLabel}}/g, comboItemLabel);


    //Add Gold Info
    //console.log("JD DATA HERE:");
    //console.log(data);
    //console.log(data.title, data.tags);
    for (var t in data.tags){
      //console.log(data.tags[t]);

      if(data.tags[t].indexOf("14K ONLY") >= 0){
        itemHtml = itemHtml.replace('<div id="jd-hidden" style="display: none;"></div>', '<div class="product-gold-info" style="background: #FBF0DA; color: #000;"><span>14K Gold</span></div>');
      }

      if(data.tags[t].indexOf("Swarovski") >= 0){
        itemHtml = itemHtml.replace('<div id="jd-hidden" style="display: none;"></div>', '<div class="product-gold-info" style="background: #fff6f7; color: #000;"><span>SWAROVSKI®️</span></div>');
      }

      if(data.tags[t] == "lab-diamond" || data.tags[t] == "Lab Grown Diamonds" ){
        if(data.tags.includes("purple-dot-live-waitlist")){
          itemHtml = itemHtml.replace('<div id="jd-hidden" style="display: none;"></div>', '<div class="product-gold-info jd-lab-diamonds-br" style="background: #edf7ff; color: #000;"><span>LAB DIAMOND</span></div>');
        } else {
          itemHtml = itemHtml.replace('<div id="jd-hidden" style="display: none;"></div>', '<div class="product-gold-info jd-lab-diamonds" style="background: #edf7ff; color: #000;"><span>LAB DIAMOND</span></div>');
        }
        //console.log("JUNAID TAG CHECK LAB GROWN");
      } else if(data.tags[t] == "Diamond"){
        if(data.tags.includes("purple-dot-live-waitlist")){
          itemHtml = itemHtml.replace('<div id="jd-hidden" style="display: none;"></div>', '<div class="product-gold-info jd-natural-diamonds-br" style="background: #c7e6ff; color: #000;"><span>NATURAL DIAMONDS</span></div>');
        } else {
          itemHtml = itemHtml.replace('<div id="jd-hidden" style="display: none;"></div>', '<div class="product-gold-info jd-natural-diamonds" style="background: #c7e6ff; color: #000;"><span>NATURAL DIAMONDS</span></div>');
        }
        //console.log("JUNAID TAG CHECK NATURAL GROWN");
      }

      if(data.tags[t].indexOf("Mens Jewelry") >= 0){
        itemHtml = itemHtml.replace('<div id="jd-hidden" style="display: none;"></div>', '<div class="product-gold-info" style="background: #424242; color: #ffffff;"><span>MEN\'S JEWELRY</span></div>');
      }

      if(data.tags[t].indexOf("Necklace Charms") >= 0 || data.tags[t].indexOf("necklace charms") >= 0){
        itemHtml = itemHtml.replace('<div id="jd-hidden" style="display: none;"></div>', '<div class="product-gold-info" style="background: #EFCEC3;"><span>PENDANT</span></div>');
      }
    }

    if(jd_enable_sale == true && jd_sale_type != "none"){
      var jdSalePercentage = (data.compare_at_price_min - (data.price_min*jd_sale_percentage)) / data.compare_at_price_min * 100;
    } else {
      var jdSalePercentage = (data.compare_at_price_min - data.price_min) / data.compare_at_price_min * 100;
    }
    
    if (onSale) {
    itemHtml = itemHtml.replace('{{jdDiscountedPercentage}}', '<div class="sale-item icn">'+Math.trunc(jdSalePercentage) + "% OFF</div>");
    } else {
    itemHtml = itemHtml.replace('{{jdDiscountedPercentage}}', '');
    }

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    /* JUNAID'S MULTI CURRENCY SUPPORT REVERT SNIPPET */

    // Add price
    //var currency = Shopify.currency.active;
    var currency = "";
    //console.log("JD ACTIVE CURRENCY:", currency);
    if (currency == "USD")
      currency = "";
    //console.log("PRODUCT DATA FROM BOOST:", data);

    var jdUnlockCookie = {
      getCookie: function(name) {
        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
      },
      setCookie: function(name, value, mins) {
        var d = new Date;
        d.setTime(d.getTime() + 60*1000*mins);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
      },
      deleteCookie:function(name) { setCookie(name, '', -1); }
    }
    
    var itemPriceHtml = '';
    if (onSale) {
      itemPriceHtml += '<div translate="no" class="onsale">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + ' ' + currency + '</div>';
      itemPriceHtml += '<div translate="no" class="was" style="color: black;" style="font-size: 14px;">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + ' ' + currency + '</div>';
      itemPriceHtml += '<div class="onsale jd-onsale" style="font-size: 14px;">Buy 1, Get 1 FREE</div>';
      if(jd_enable_sale == true && jd_sale_type == "sitewide"){
        itemPriceHtml += '<div translate="no" class="onsale jd-onsale" style="font-size: 14px;">Sale Price ' + Utils.formatMoney(data.price_min*jd_sale_percentage, Globals.moneyFormat) + ' ' + currency + '</div>';
        console.log("test ", data.title +  Utils.formatMoney(data.price_min*jd_sale_percentage, Globals.moneyFormat))
        if (jd_discount_notice != false) itemPriceHtml += '<div class="onsale jd-onsale" style="font-size: 14px;">'+jd_discount_notice+'</div>';
      } else if( jd_enable_sale == true && jd_sale_type == "saleitems" && data.collections.some(e => e.handle === 'sale')){
        if (priceVaries) {
          itemPriceHtml += '<div translate="no" class="onsale jd-onsale" style="font-size: 14px;">Sale Price From ' + Utils.formatMoney(data.price_min*jd_sale_percentage, this.moneyFormat) + ' ' + currency + '</div>';
          if (jd_discount_notice != false) itemPriceHtml += '<div class="onsale jd-onsale" style="font-size: 14px;">'+jd_discount_notice+'</div>';
        } else {
          itemPriceHtml += '<div translate="no" class="onsale jd-onsale">Sale Price ' + Utils.formatMoney(data.price_min*jd_sale_percentage, Globals.moneyFormat) + ' ' + currency + '</div>';
          if (jd_discount_notice != false) itemPriceHtml += '<div class="onsale jd-onsale" style="font-size: 14px;">'+jd_discount_notice+'</div>';
        }
      } else if(jd_enable_sale == true && jd_sale_type == "activation" && jdUnlockCookie.getCookie("jd-sale-unlock") != null){
        if (priceVaries) {
          itemPriceHtml += '<div translate="no" class="onsale jd-onsale" style="font-size: 14px;">Exclusive Price From ' + Utils.formatMoney(data.price_min*jd_sale_percentage, this.moneyFormat) + ' ' + currency + '</div>';
        } else {
          itemPriceHtml += '<div translate="no" class="onsale jd-onsale">Exclusive Price: ' + Utils.formatMoney(data.price_min*jd_sale_percentage, Globals.moneyFormat) + ' ' + currency + '</div>';  
        }
      }
    } else {
      if (priceVaries) {
        itemPriceHtml += '<div translate="no" class="prod-price">'+boostPFSConfig.label.from_price + ' ' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + ' ' + currency + ' -  ' + Utils.formatMoney(data.price_max, Globals.moneyFormat) + ' ' + currency+'</div>';
        itemPriceHtml += '<div class="onsale jd-onsale" style="font-size: 14px;">Buy 1, Get 1 FREE</div>';
        if(jd_enable_sale == true && jd_sale_type == "sitewide"){
          itemPriceHtml += '<div translate="no" class="onsale jd-onsale">Sale Price '+boostPFSConfig.label.from_price + ' ' + Utils.formatMoney(data.price_min*jd_sale_percentage, Globals.moneyFormat) + ' ' + currency + ' -  ' + Utils.formatMoney(data.price_max*jd_sale_percentage, Globals.moneyFormat) + ' ' + currency+'</div>';
          if (jd_discount_notice != false) itemPriceHtml += '<div class="onsale jd-onsale" style="font-size: 14px;">'+jd_discount_notice+'</div>';
        } else if( jd_enable_sale == true && jd_sale_type == "saleitems" && data.collections.some(e => e.handle === 'sale')){
          itemPriceHtml += '<div translate="no" class="onsale jd-onsale" style="font-size: 14px;">Sale Price From ' + Utils.formatMoney(data.price_min*jd_sale_percentage, this.moneyFormat) + ' ' + currency + '</div>';
          if (jd_discount_notice != false) itemPriceHtml += '<div class="onsale jd-onsale" style="font-size: 14px;">'+jd_discount_notice+'</div>';
        } else if(jd_enable_sale == true && jd_sale_type == "activation" && jdUnlockCookie.getCookie("jd-sale-unlock") != null){
          itemPriceHtml += '<div translate="no" class="onsale jd-onsale" style="font-size: 14px;">Exclusive Price From ' + Utils.formatMoney(data.price_min*jd_sale_percentage, this.moneyFormat) + ' ' + currency + '</div>';
        }
      } else {
        itemPriceHtml += '<div translate="no" class="prod-price">'+Utils.formatMoney(data.price_min, Globals.moneyFormat) + ' ' + currency+'</div>';
        itemPriceHtml += '<div class="onsale jd-onsale" style="font-size: 14px;">Buy 1, Get 1 FREE</div>';
        if(jd_enable_sale == true && jd_sale_type == "sitewide"){
          itemPriceHtml += '<div translate="no" class="onsale jd-onsale" style="font-size: 14px;">Sale Price '+Utils.formatMoney(data.price_min*jd_sale_percentage, Globals.moneyFormat) + ' ' + currency+'</div>';
          if (jd_discount_notice != false) itemPriceHtml += '<div class="onsale jd-onsale" style="font-size: 14px;">'+jd_discount_notice+'</div>';
        } else if( jd_enable_sale == true && jd_sale_type == "saleitems" && data.collections.some(e => e.handle === 'sale')){
          itemPriceHtml += '<div translate="no" class="onsale jd-onsale" style="font-size: 14px;">Sale Price ' + Utils.formatMoney(data.price_min*jd_sale_percentage, this.moneyFormat) + ' ' + currency + '</div>';
          if (jd_discount_notice != false) itemPriceHtml += '<div class="onsale jd-onsale" style="font-size: 14px;">'+jd_discount_notice+'</div>';
        } else if(jd_enable_sale == true && jd_sale_type == "activation" && jdUnlockCookie.getCookie("jd-sale-unlock") != null){
          itemPriceHtml += '<div translate="no" class="onsale jd-onsale" style="font-size: 14px;">Exclusive Price: ' + Utils.formatMoney(data.price_min*jd_sale_percentage, this.moneyFormat) + ' ' + currency + '</div>';
        }
      }
      //itemPriceHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add itemImages
    var itemImagesHtml = '';
    var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '500x') : boostPFSConfig.general.no_image_url;
    if (images.length > 0) {
      var aspect_ratio = images[0]['height'] / images[0]['width'] * 100;
      var firstImageCLass = (images.length > 0 && boostPFSConfig.custom.secondary_images_hover == 'image-flip') ? 'first-image' : '';
      itemImagesHtml += '<div class="box-ratio">' +
        '<img class=" ' + firstImageCLass + '"' +
        'src="' + Utils.optimizeImage(images[0]['src'], '1024x') + '"' +
        'data-sizes="auto"' +
        'data-original="' + itemThumbUrl + '"' +
        'alt="{{itemTitle}}">' +
        '</div>' +
        '<noscript>' +
        '<img src="' + Utils.optimizeImage(images[0]['src'], '1024x') + '" alt="{{itemTitle}}">' +
        '</noscript>';
      if (boostPFSConfig.custom.secondary_images_hover == 'alternate_colors' && images.length > 1) {
        var aspect_ratio1 = images[1]['height'] / images[1]['width'] * 100;
        itemImagesHtml += '<div class="hidden">'+
          '<div class="box-ratio">' +
          '<img class=""' +
          'src="' + Utils.optimizeImage(images[1]['src'], '1024x') + '"' +
          'data-sizes="auto"' +
          'data-original="' + itemThumbUrl + '"' +
          'alt="{{itemTitle}}">' +
          '</div>' +
          '<noscript>' +
          '<img src="' + Utils.optimizeImage(images[1]['src'], '1024x') + '" alt="{{itemTitle}}">' +
          '</noscript>' +
          '</div>';
      }
    } else {
      itemImagesHtml += '<img src="' + itemThumbUrl + '">';
    }

    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Quick view
    var itemQuickViewHtml = boostPFSConfig.custom.quick_view_enable ? boostPFSTemplate.quickViewHtml : '';
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    // Add Swatches
    var itemSwatchHtml = '';
    if (boostPFSConfig.custom.secondary_images_hover == 'alternate_colors' && images.length > 1) {
      for (var k = 0; k < data.options_with_values.length; k++) {
        var option = data['options_with_values'][k]['name'];
        var option_handle = Utils.slugify(option);
        var option_index = k;

        var is_color = false;
        var downcased_option = option.toLowerCase();
        if (downcased_option.indexOf('color') > -1 || downcased_option.indexOf('colour') > -1) {
          itemSwatchHtml += '<div class="col-swatch">'
          itemSwatchHtml += '<ul data-option-index="' + option_index + '" class="' + option_handle + ' options">';
          var values = '';
          var optionValues = data['options_with_values'][k]['values'];
          for (var i = 0; i < optionValues.length; i++) {
            var value = optionValues[i]['title'];
            var wrapped_value = ',' + value + ',';
            if (values.indexOf(wrapped_value) == -1) {
              var variantImage = "";
              if (optionValues[i]['image'] != null) {
                var imageIndex = optionValues[i]['image'];
                if (typeof (images[imageIndex - 1]) !== 'undefined') {
                  variantImage = Utils.optimizeImage(images[imageIndex - 1]['src']);
                }
              }
              var fileColorUrl = boostPFSConfig.general.asset_url.replace('boost-pfs.js', Utils.slugify(value) + '.png');
              
              var jdVariantID = "";
              $(data.variants).each(function(i, e){
                if(value == e.option_color){
                  jdVariantID = e.id;
                }
              });

              if(i == 0) {
                itemSwatchHtml += '<li data-option-title="' + value + '" data-variant-id="'+ jdVariantID +'" data-href="' + variantImage + '" class="swatch-active color ' + Utils.slugify(value) + '">';
              } else {
                itemSwatchHtml += '<li data-option-title="' + value + '" data-variant-id="'+ jdVariantID +'" data-href="' + variantImage + '" class="color ' + Utils.slugify(value) + '">';  
              }
              itemSwatchHtml += '<span style="background-color: ' + Utils.slugify(value.split(' ').pop()) + '; background-image: url(' + fileColorUrl + ')"></span>';
              itemSwatchHtml == '</li>';
              values += values + wrapped_value;
            }
          }
          itemSwatchHtml += '</ul>';
          itemSwatchHtml += '</div>';
        }
      }

       			itemSwatchHtml += '<script>' +
       				"$('#product-listing-{{itemId}} .col-swatch li').each(function(){" +
       					"var Original = $('#product-listing-{{itemId}} .prod-image img').attr('data-original'); " +
       					"$(this).hover(function() {" +
                            "$(this).parent().find('li').removeClass('swatch-active');" +
                            "$(this).addClass('swatch-active');" +
       						"var newImage = $(this).attr('data-href');" +
       						"if (newImage){"+
       							"$( '#product-listing-{{itemId}} .prod-image img' ).attr({ srcset: newImage }); " +
       						"}" +
       						"return false;" +
       					"}, function(){" +
       						//"$('#product-listing-{{itemId}} .prod-image img' ).attr({ srcset: Original }); " +
       					"});" +
       				"});" +
       			'</script>';
    }
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);

    // Add Reviews
    if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
    }

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemPriceNumber}}/g, data.price_min);
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title.replace("Adina", "Adina Eden"));
    itemHtml = itemHtml.replace(/{{firstVariantId}}/g, firstVariant.id);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data)+"?variant="+firstVariant.id);

    return itemHtml;
  }

  function buildItemGridClass(itemClass, index, productsPerRow) {
    var temp = index < productsPerRow ? index : index % productsPerRow;
    if (temp == 1) { itemClass += ' first'; } else if (temp == 0) { itemClass += ' last'; };

    var jdTemp = index < 3 ? index : index % 3;
    if (jdTemp == 1) { itemClass += ' desktop-small-first'; } else if (jdTemp == 0) { itemClass += ' desktop-small-last'; };
    return itemClass;
  }

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if(!totalProduct) totalProduct = this.totalProduct;

    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage !== 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage -1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }

    return '';
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content 
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
        }
        var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data, eventType) {
    const nostoFilterCallback = new Event('nostoFilterCallback');
    setTimeout(function(){
      document.dispatchEvent(nostoFilterCallback);
    }, 500);


     jQ('#jd-mobile-filter').on('click', function () {
      jQ('body').addClass('boost-pfs-filter-tree-open-body');
    })

    if($("body").hasClass("search")){
      jQ('.boost-pfs-search-result-number').addClass('loaded');

      setTimeout(function(){
        var jdSearchText = jQ(".boost-pfs-search-result-number.loaded").text();
        jQ('head > title').text("Search: " + jdSearchText.replace("Showing ", ""));
      }, 500);
    }
  };

  // Build additional elements
  FilterResult.prototype.afterRender = function (data) {
    if(!data) data = this.data;

    // Build Total Products
    if (Settings.getSettingValue('general.paginationType') == 'default') {
      var from = Globals.queryParams.page == 1 ? Globals.queryParams.page : (Globals.queryParams.page - 1) * Globals.queryParams.limit + 1;
      var to = from + data.products.length - 1;
      jQ('#pagination').find('.count').html(boostPFSConfig.label.showing_items + ' ' + from + '-' + to + ' ' + boostPFSConfig.label.pagination_of + ' ' + data.total_product);

      // Build Top Pagination info
      var currentPage = parseInt(Globals.queryParams.page);
      var totalPage = Math.ceil(data.total_product / Globals.queryParams.limit);
      jQ('.boost-pfs-filter-top-pagination').find('.pagination-count').html(currentPage + ' ' + boostPFSConfig.label.pagination_of + ' ' + totalPage + ' ');
    } else {
      jQ('#pagination .count').hide();
      jQ('#pagination .clear').hide();
      jQ('.boost-pfs-filter-top-pagination').hide();
    }


    var val = Globals.queryParams.pf_p_price
    if(val != null || val != undefined) {
      var arr = val[0].split(':')
      if(arr.indexOf('250.00') != -1) {
        jQ('.currency-boost-max').each(function(){
          jQ(this).addClass('add-plus')
        })
      }
      else {
        jQ('.currency-boost-max').each(function(){
          jQ(this).removeClass('add-plus')
        })
      }
    }


    jQ('.refine-by-value').each(function(){
      var plus = jQ(this).text()
      plus = plus.replace('250', '250+')
      jQ(this).text(plus)
    })
    
  };

  Filter.prototype.afterRender = function (data ,eventType) {
    if(!data) data = this.data;
    
    if (!eventType) eventType = this.eventType;
    jQ('body').addClass('boost-pfs-filter-tree-open-body');
     jQ('.boost-pfs-filter-total-products').html(data.total_product + ' products');
  }

  var getBlockContentTemplate = FilterOptionRangeSlider.prototype.getBlockContentTemplate;
  
  /*
  FilterOptionRangeSlider.prototype.getBlockContentTemplate = function() {

    if(Shopify.currency.active == "GBP"){
      var jdft_iso = "£";
    } else if(Shopify.currency.active == "EUR") {
      var jdft_iso = "€";
    } else {
      var jdft_iso = "$";
    }
    if (this.hideInputElement) {
      return `
<div>
<div class="boost-pfs-filter-option-range-slider"></div>
</div>
`.trim();
    } else {
      if (this.style == 'style3') {
        return `
<div class="boost-pfs-filter-block-content-inner">
<div class="boost-pfs-filter-option-range-slider"></div>
<div class="boost-pfs-filter-option-range-amount">
<span class="currency-boost">${jdft_iso}</span><input class="boost-pfs-filter-option-range-amount-min" type="text" role="textbox" readonly />
<span class="currency-boost">${jdft_iso}<input class="boost-pfs-filter-option-range-amount-max" type="text" role="textbox" readonly />
</div>
</div>
`.trim();
      } else {
        return `
<div class="boost-pfs-filter-block-content-inner">
<div class="boost-pfs-filter-option-range-amount">
<span class="currency-boost-min">${jdft_iso}</span><input class="boost-pfs-filter-option-range-amount-min" role="textbox" type="text" />
<div class="boost-pfs-filter-option-range-amount-split"> - </div>
<span class="currency-boost-max add-plus">${jdft_iso}</span><input class="boost-pfs-filter-option-range-amount-max" role="textbox" type="text" />
</div>
<div class="boost-pfs-filter-option-range-slider"></div>
</div>
`.trim();
      }

    }
  }
*/
  /*
  FilterOptionItemRangeSlider.prototype.setData = function(data) {
    //super.setData(data);

    if (data.min != null && data.max != null) {
      data.min = 20;
      data.max = 250;
      this.key = this.parent.filterOptionId;
      this.value = data.min + ":" + data.max ;
    }
  }
  */
  
  FilterOptionRangeSlider.prototype.getSliderRange = function() {
		var range = {
			'min': 20,
			'max': 250
		}
		if (!this.isNumberRangeSlider) {
			for (var i = 1; i < this.valuesData.length; i++) {
				var percent = i * (100 / (this.valuesData.length));
				range[percent + '%'] = i;
			}
		}
		return range;
	}
  
  FilterOptionRangeSlider.prototype.renderInputField = function() {
        if(this.currentMin < 20){
            this.currentMin = 20;
        }
    	if(this.currentMax > 250){
            this.currentMax = 250;
        }
    
		if (this.$element && !this.hideInputElement) {
			if (!this.$minInputElement || !this.$maxInputElement) {
				this.$minInputElement = this.$element.find('.boost-pfs-filter-option-range-amount-min');
				this.$maxInputElement = this.$element.find('.boost-pfs-filter-option-range-amount-max');
			}
			var formatNumberMin = this.buildNumberLabel(this.currentMin);
			var formatNumberMax = this.buildNumberLabel(this.currentMax);
			this.$minInputElement.val(Utils.getCurrency()+formatNumberMin);
            if(formatNumberMax == 250){
              	this.$maxInputElement.val(Utils.getCurrency()+formatNumberMax + '+');
            }else{
            	this.$maxInputElement.val(Utils.getCurrency()+formatNumberMax);
            }
		}
	}
  
  FilterOptionItem.prototype.onClick = function(event) {
		if (event) {
			event.preventDefault();
		}
		if (!this.isDisabled()) {
			if (this.requestInstantly || this.parent.filterType == FilterOptionEnum.FilterType.COLLECTION) {
				this.onApplyFilter();
			} else {
				this.onSelectFilter();
			}
		}
	};
  
  FilterOptionItem.prototype.onApplyFilter = function() {
		var filterType = this.parent.filterType;
		var displayType = this.parent.displayType;
		var selectType = this.parent.selectType;
		var filterOptionId = this.parent.filterOptionId;
		var isEmptyAllCollection = this.handle == 'all' && this.docCount == 0 && filterType == FilterOptionEnum.FilterType.COLLECTION;
		
		if (this.docCount > 0 || this.parent.keepValuesStatic || displayType == FilterOptionEnum.DisplayType.RANGE || isEmptyAllCollection) {
			// This is action of clicking of user, not browser event
			Globals.internalClick = true;
			var eventType = '';

			// If filter by collection, set collectionId param, change address bar and window title
			if (filterType == FilterOptionEnum.FilterType.COLLECTION) {
				this.isSelected = true;
				Globals.collectionId = this.collectionId;
				FilterApi.setParam('collection_scope', this.collectionId);

				// If search page, adds pf_c_collection param
				if (!Utils.isCollectionPage()) {
					FilterApi.setParam(filterOptionId, this.collectionId);
				// If collection page, change collection URL
				} else {
					Navigation.setAddressBarPathAfterFilter('/collections/' + this.handle);
					Navigation.setWindowTitleAfterFilter(Utils.stripHtml(this.label) + ' - ' + Globals.shopName);

					// Set new sort order on collection pages, and make it the default
					FilterApi.setParam('sort', this.sortOrder);
					Globals.defaultSorting = this.sortOrder;
				}

				// Clear all filter option params except collection
				var currentFilterOptionIds = [];
				Object.keys(Globals.queryParams).forEach(queryParam => {
					if (queryParam.startsWith(Globals.prefix) && !queryParam.startsWith(Globals.prefix  + '_c')) {
						currentFilterOptionIds.push(queryParam);
					}
				});

				currentFilterOptionIds.forEach(filterOptionId => {
					FilterApi.setParam(filterOptionId, null);
				});

				eventType = 'collection';
			
			// Else, set the filter option value(s)
			} else {

				// Toggle the selected state
				this.isSelected = !this.isSelected;

				// The values array to send to API
				var values = null;

				// If single option, set or clear the value based on selected state
				if (selectType == FilterOptionEnum.SelectType.SINGLE) {
					values = this.isSelected ? [this.value] : [];

				// If multiple option, remove or add the new value based on selected state
				} else {

					// Get existing value(s)
					values = Globals.queryParams[filterOptionId];
					if (!Array.isArray(values)){
						values = [];
					}

					if (this.isSelected) {
						// Add new value to existing values array
						if (!values.includes(this.value)) {
							values.push(this.value);
						}
					} else {
						// Remove value from existing values array
						values = values.filter(x => x !== this.value);
					}
				}
				FilterApi.setParam(filterOptionId, values);
				FilterApi.setParam(filterOptionId + '_and_condition', this.parent.useAndCondition && values.length > 0 ? true : null);
				FilterApi.setParam(filterOptionId + '_show_exact_rating', this.parent.showExactRating && values.length > 0 ? true : null);
				FilterApi.setParam(filterOptionId + '_exclude_from_value', this.parent.excludePriceFromValue && values.length > 0 ? true : null);
				FilterApi.setParam(filterOptionId.replace(Globals.prefix + '_l_', Globals.prefix + '_li_').replace(Globals.prefix + '_vl_', Globals.prefix + '_vli_') + '_ibsl', this.parent.inventoryBaseSelectedLocations && values.length > 0 ? true : null);
				eventType = 'filter';
			}

			// Reset the page param
			FilterApi.setParam('page', 1);

			var eventInfo = {
				filterOptionId: filterOptionId,
				filterValue: this.value
			}
			FilterApi.applyFilter(eventType, eventInfo);
		}
	}
  
  	FilterRefineByItem.prototype.buildLabelRange = function() {
		var label = '';
		if (this.filterOption) {
          	//console.log(this.filterOption);
			if (this.filterOption.isNumberRangeSlider) {
				var values = this.filterItemId.split(':');
                if(this.filterOption.filterType == 'price'){
                  if (values && values.length == 2) {
                      var minLabel = this.filterOption.buildLabel(values[0]);
                      var maxLabel = this.filterOption.buildLabel(values[1]);
                      if (minLabel == maxLabel) {
                          label = '$'+ minLabel;
                      } else {
                          label = '$'+ minLabel + ' - ' + '$' + maxLabel;
                      }
                  }
                }else{
                  if (values && values.length == 2) {
                      var minLabel = this.filterOption.buildLabel(values[0]);
                      var maxLabel = this.filterOption.buildLabel(values[1]);
                      if (minLabel == maxLabel) {
                          label = minLabel;
                      } else {
                          label = minLabel + ' - ' + maxLabel;
                      }
                  }
                }
			} else {
				var values = this.filterItemId;
				var minLabel = '';
				var maxLabel = '';
				// Get label from filter option data
				if ((this.filterOption.currentMax - 1 > 0)
					&& (this.filterOption.currentMax - 1 < this.filterOption.valuesData.length)) {
					minLabel = this.filterOption.valuesData[this.filterOption.currentMin].key;
					maxLabel = this.filterOption.valuesData[this.filterOption.currentMax - 1].key;

				// Fallback: get label from filter item id
				} else if (Array.isArray(values) && values.length > 0){
					minLabel = values[0];
					maxLabel = values[values.length - 1];
				}

				// Remove prefix
				if (this.filterOption.prefix) {
					var prefix = this.filterOption.prefix.replace(/\\/g, '');
					minLabel = minLabel.replace(prefix, '').trim();
					maxLabel = maxLabel.replace(prefix, '').trim();
				}

				// Build label min-max
				if (minLabel == maxLabel) {
					label = minLabel;
				} else {
					label = minLabel + ' - ' + maxLabel;
				}
			}
		}
		return label;
	}
    
    FilterOptionRangeSlider.prototype.getSliderConfig = function() {
		var sliderConfig = {
			start: this.isSingleHandle ? [this.currentMin] : [this.currentMin, this.currentMax],
			step: this.sliderStep,
			connect: true,
			snap: !this.isNumberRangeSlider,
			animate: true,
			animationDuration: 300,
			range: {
              'min': 20,
              '25%' : 50,
              '50%' : 100,
              '75%' : 150,
              'max': 250 
            },
			pips: this.getSliderPipsConfig()
		}
		if (this.isShowTooltip) {
			var tooltipFormat = {
				to: this.buildLabel.bind(this)
			}
			sliderConfig.tooltips = [tooltipFormat, tooltipFormat];
		}
		return sliderConfig;
	}
    
    FilterOptionRangeSlider.prototype.getSliderPipsConfig = function() {
		var numberOfPips = this.isNumberRangeSlider ? (this.sliderRange + 1) : this.valuesData.length + 1;
		if (numberOfPips < 2) numberOfPips = 2;
		var pipConfig = {
			mode: 'values',
			values: [20, 50, 100, 150, 250],
			filter: (value, type) => { return (type == 1) ? type : -1 }, // Only render big pip
			format: {
				to: this.buildLabel.bind(this)
			}
		}
		return pipConfig;
	}

  FilterApi.beforeCall = function(eventType, eventInfo) {
     if(Utils.isSearchPage()) {
       Globals.queryParams.product_available = true;
       Globals.queryParams.variant_available = true;
     }
}


})();

/*$(document).on('mouseenter', '.col-swatch li', function() {
  var $Original = $(this).parents('.product-index').find('.prod-image .reveal .box-ratio').attr('srcset');
  var newImage = $(this).attr('data-href');
  if (newImage) {
    $(this).parents('.product-index').find('.prod-image .reveal .box-ratio img').attr({ srcset: newImage });
  }
  return false;
});*/





jQ(document).ready(function(){
  if(Shopify.currency.active == "GBP"){
    var jdft_iso = "£";
  } else if(Shopify.currency.active == "EUR") {
    var jdft_iso = "€";
  } else {
    var jdft_iso = "$";
  }

  $("#jd-desktop-sortby-trigger").click(function(e){
    e.preventDefault();
    $(this).toggleClass("selected");
  });
  
  $(document).click(function() {
    var container = $("#jd-desktop-sortby-trigger");
    if (!container.is(event.target) && !container.has(event.target).length) {
      container.removeClass("selected");
    }
  });
});

